/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// config = () => {
  // if (window.innerWidth <= 780) return ['66.66%', 'center']
  // if (window.innerWidth <= 1166) return ['33%', 'center']
  // if (window.innerWidth <= 1100) return ['80%', 'center']
// }

function runStepsSlider() {
  new Flickity('#press_logo_mobile_carousel', {
    prevNextButtons: true,
    groupCells: 2,
    lazyLoad: 2,
    cellAlign: 'center',
    freeScroll: false,
    initialIndex: 0,
    pageDots: false,
    wrapAround: true,
    arrowShape: { 
      x0: 10,
      x1: 60, y1: 50,
      x2: 60, y2: 45,
      x3: 15
    }
  });
};

var pressLogo
window.addEventListener('DOMContentLoaded', function() {
  pressLogo = document.querySelector('#press_logo_mobile_carousel')
  if (pressLogo) {
    runStepsSlider()
  }
})
window.addEventListener('resize', function() {
  if (pressLogo) {
    runStepsSlider()
  }
});




/*!	
* FitText.js 1.0 jQuery free version
*
* Copyright 2011, Dave Rupert http://daverupert.com 
* Released under the WTFPL license 
* http://sam.zoy.org/wtfpl/
* Modified by Slawomir Kolodziej http://slawekk.info
*
* Date: Tue Aug 09 2011 10:45:54 GMT+0200 (CEST)
*/

(() => {
  var addEvent = function (el, type, fn) {
    if (el.addEventListener)
      el.addEventListener(type, fn, false);
    else
      el.attachEvent('on'+type, fn);
  };
  
  var extend = function(obj,ext){
    for(var key in ext)
      if(ext.hasOwnProperty(key))
        obj[key] = ext[key];
    return obj;
  };

  window.fitText = function (el, kompressor, options) {

    var settings = extend({
      'minFontSize' : -1/0,
      'maxFontSize' : 1/0
    },options);

    var fit = function (el) {
      var compressor = kompressor || 1;

      var resizer = function () {
        el.style.fontSize = Math.max(Math.min(el.clientWidth / (compressor*10), parseFloat(settings.maxFontSize)), parseFloat(settings.minFontSize)) + 'px';
      };

      // Call once to set.
      resizer();

      // Bind events
      // If you have any js library which support Events, replace this part
      // and remove addEvent function (or use original jQuery version)
      addEvent(window, 'resize', resizer);
      addEvent(window, 'orientationchange', resizer);
    };

    if (el.length)
      for(var i=0; i<el.length; i++)
        fit(el[i]);
    else
      fit(el);

    // return set of elements
    return el;
  };

  // call texts you need to fit to their parents here
  knownFromText = document.querySelector('.mobile_heading h2')
  
  window.adjustKnownFromTextWidth = function() {
    if (knownFromText && window.innerWidth > 350 && window.innerWidth < 390) {
      fitText(knownFromText, .6)
    }
    if (knownFromText && window.innerWidth < 621) {
      fitText(knownFromText, .69)
    } else if (knownFromText) {
      fitText(knownFromText)
    }
  }
  window.addEventListener('DOMContentLoaded', adjustKnownFromTextWidth)
  window.addEventListener('resize', adjustKnownFromTextWidth)
})()